import { Col } from "react-bootstrap";

export const ProjectCards = ({ project }) => {
  const { title, description, imgUrl, preview, about } = project;
  const isGithub = !!preview && preview.includes("github.com");
  const ctaLabel = isGithub ? "Github" : "View";

  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-card">
        <div className="proj-imgbx">
          <img src={imgUrl} alt={title} />
          <div className="proj-txtx">
            <h4>{title}</h4>
            <span>{description}</span>
            <div className="proj-txtx-actions">
              <a
                href={preview}
                target="_blank"
                rel="noreferrer"
                className="proj-txtx-cta"
              >
                {ctaLabel} <span aria-hidden="true"></span>
              </a>
              {about && (
                <a
                  href={about}
                  target="_blank"
                  rel="noreferrer"
                  className="proj-txtx-cta proj-txtx-cta-secondary"
                >
                  Learn more <span aria-hidden="true"></span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};
